import React from "react";
import { useEffect, useState } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import { Services } from "../../api/Services";
// Set the locale globally (optional)
import ReactPaginate from "react-paginate";
import { useNavigate, Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import gymgirl from "../../images/gymgirl.jpg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_URL_MEDIA } from "../../api/Constants";
import { BASE_URL_COMPETITION } from "../../api/Constants";
import { getImageUrl } from 'components/helpers/Helpers';
import VideoPlayerOverlay from "../workout/common/VideoPlayerOverlay";

const TrainerPrograms = () => {
  const [sinfo, setsInfo] = useState(false);
  const [programms, setProgramms] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  // Video overlay state
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [videoTitle, setVideoTitle] = useState("Video");

  const openVideo = (programm) => {
    setVideoUrl(programm?.video || "");
    setVideoTitle(programm?.name || "Video");
    setIsVideoOpen(true);
  };

  //===================>> Trainer program section start =========================>>
  //start functions to call programs

  const handlePageClick = (event) => {
    getProgramms(event.selected + 1);
  };

  //show info function
  const showinfo = (name, desc) => {
    setsInfo(true);
    setName(name);
    setDesc(desc);
  };

  //close info
  const closeInfo = () => {
    setsInfo(false);
    setName("");
    setDesc("");
  };
  //APi call for program list
  const getProgramms = async (
    page = 1,
    is_for_progress,
    keyword,
    groupid,
    goal,
    weekly,
    monthly
  ) => {
    setIsLoading(true);
    try {
      const result = await Services.getProgrammsList(
        page,
        is_for_progress,
        keyword,
        groupid,
        goal,
        weekly,
        monthly
      );

      if (result?.status === 401) {
          setIsLoading(false);
          localStorage.clear();
          navigate("/trainer/");
      }else if (result.status === 200) {
        console.log("developers", result);
        setProgramms(result?.data?.data);
        setPageCount(result?.data?.paging?.total_pages);
      } else {
        toast.error("Some error", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const excersieCount = (exercises) => {
    const totalExerciseCount = exercises.reduce((total, workout) => {
      return total + workout.exercises.length;
    }, 0);
    return totalExerciseCount;
  };

  const daysCount = (days) => {
    const uniqueDaysArray = [
      ...new Set(days.flatMap((workout) => workout.day.split(","))),
    ];

    // Step 2: Count the number of unique days
    const uniqueDaysCount = uniqueDaysArray.length;
    return uniqueDaysCount;
  };

  const clearData = () => {
    localStorage.removeItem("cday");
    localStorage.removeItem("cweek");
  };

  //===================>> Trainer program section end =========================>>

  useEffect(() => {
    getProgramms(1);
  }, []);
  return (
    <div>
      {sinfo && (
        <div className="infoo">
          <div className="header">
            <span className="title">{name}</span>
          </div>
          <div className="desc">
            <span>{desc}</span>
          </div>
          <div className="footer" onClick={() => closeInfo()}>
            Ok
          </div>
        </div>
      )}
      <VideoPlayerOverlay
        isOpen={isVideoOpen}
        onClose={() => setIsVideoOpen(false)}
        url={videoUrl}
        title={videoTitle}
      />
      <div className="top-title">
        <h2 className="title">My listing</h2>
        <Link to="/create-program" className="button">
          Create a programm
        </Link>
      </div>
      {programms.length > 0 && (
        <div className="row">
          {programms?.map((programm) => (
            <div className="col-12 col-md-4 col-lg-3">
              <div className="programm-wrapper ">
                <div
                  className="image pointer"
                  onClick={() => {
                    navigate(`/programmdetail/${programm?.id}`);
                    clearData();
                  }}
                >
                  {programm?.image !== null ? (
                    <img
                      src={getImageUrl(programm?.image, BASE_URL_MEDIA)}
                    />
                  ) : (
                    <img src={gymgirl} />
                  )}
                </div>
                <div className="content">
                  <div className="header_title">
                    <p className="program-name">{programm?.name}</p>
                    <span className="icon">
                      {programm?.video && (
                        <i
                          className="fa fa-video"
                          title="Play video"
                          role="button"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            openVideo(programm);
                          }}
                        ></i>
                      )}
                    </span>
                  </div>
                  <div className="data">
                    {programm?.type === "weekly" ? (
                      <div className="item">
                        <div className="icon">
                          <span>{daysCount(programm?.workouts)}</span>
                          <i className="fa-regular fa-calendar-days"></i>
                        </div>
                        <div className="value">
                          <span>times a week</span>
                        </div>
                      </div>
                    ) : (
                      <div className="item">
                        <div className="icon">
                          <span>{programm?.number_of_weeks}</span>
                          <i className="fa-regular fa-calendar-days"></i>
                        </div>
                        <div className="value">
                          <span>Weeks</span>
                        </div>
                      </div>
                    )}
                    <div className="item">
                      <div className="icon">
                        <span>{programm?.workouts?.length}</span>
                        <i className="fa-solid fa-dumbbell"></i>
                      </div>
                      <div className="value">
                        <span>Workouts</span>
                      </div>
                    </div>
                    <div className="item">
                      <div className="icon">
                        <span>{excersieCount(programm?.workouts)}</span>
                        <i className="fa-solid fa-dumbbell"></i>
                      </div>
                      <div className="value">
                        <span>exercise</span>
                      </div>
                    </div>

                    <div
                      className="item pointer"
                      onClick={() => showinfo(programm?.name, programm?.desc)}
                    >
                      <div className="icon">
                        <i className="fa-solid fa-eye"></i>
                      </div>
                      <div className="value">
                        <span>View info</span>
                      </div>
                    </div>
                  </div>
                  <div className="community-wrapper">
                    {programm?.community?.logo && (
                      <img
                        src={getImageUrl(programm?.community?.logo, BASE_URL_MEDIA)}
                      />
                    )}
                    <div className="info-wrapper">
                      <p className="name">{programm?.community?.name}</p>
                      <p className="country">{programm?.community?.country}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {isLoading && (
        <div className="row">
          <div className="col-12 col-md-4 col-lg-3">
            <div className="programm-wrapper">
              <div className="image">
                <Skeleton height={200} duration={1.5} />
              </div>
              <div className="content">
                <div className="header_title">
                  <Skeleton height={20} width={120} duration={1.5} />
                  <Skeleton height={20} width={60} duration={1.5} />
                </div>
                <Skeleton height={30} duration={1.5} />
                <div className="data">
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4 col-lg-3">
            <div className="programm-wrapper">
              <div className="image">
                <Skeleton height={200} duration={1.5} />
              </div>
              <div className="content">
                <div className="header_title">
                  <Skeleton height={20} width={120} duration={1.5} />
                  <Skeleton height={20} width={60} duration={1.5} />
                </div>
                <Skeleton height={30} duration={1.5} />
                <div className="data">
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4 col-lg-3">
            <div className="programm-wrapper">
              <div className="image">
                <Skeleton height={200} duration={1.5} />
              </div>
              <div className="content">
                <div className="header_title">
                  <Skeleton height={20} width={120} duration={1.5} />
                  <Skeleton height={20} width={60} duration={1.5} />
                </div>
                <Skeleton height={30} duration={1.5} />
                <div className="data">
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4 col-lg-3">
            <div className="programm-wrapper">
              <div className="image">
                <Skeleton height={200} duration={1.5} />
              </div>
              <div className="content">
                <div className="header_title">
                  <Skeleton height={20} width={120} duration={1.5} />
                  <Skeleton height={20} width={60} duration={1.5} />
                </div>
                <Skeleton height={30} duration={1.5} />
                <div className="data">
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4 col-lg-3">
            <div className="programm-wrapper">
              <div className="image">
                <Skeleton height={200} duration={1.5} />
              </div>
              <div className="content">
                <div className="header_title">
                  <Skeleton height={20} width={120} duration={1.5} />
                  <Skeleton height={20} width={60} duration={1.5} />
                </div>
                <Skeleton height={30} duration={1.5} />
                <div className="data">
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4 col-lg-3">
            <div className="programm-wrapper">
              <div className="image">
                <Skeleton height={200} duration={1.5} />
              </div>
              <div className="content">
                <div className="header_title">
                  <Skeleton height={20} width={120} duration={1.5} />
                  <Skeleton height={20} width={60} duration={1.5} />
                </div>
                <Skeleton height={30} duration={1.5} />
                <div className="data">
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4 col-lg-3">
            <div className="programm-wrapper">
              <div className="image">
                <Skeleton height={200} duration={1.5} />
              </div>
              <div className="content">
                <div className="header_title">
                  <Skeleton height={20} width={120} duration={1.5} />
                  <Skeleton height={20} width={60} duration={1.5} />
                </div>
                <Skeleton height={30} duration={1.5} />
                <div className="data">
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4 col-lg-3">
            <div className="programm-wrapper">
              <div className="image">
                <Skeleton height={200} duration={1.5} />
              </div>
              <div className="content">
                <div className="header_title">
                  <Skeleton height={20} width={120} duration={1.5} />
                  <Skeleton height={20} width={60} duration={1.5} />
                </div>
                <Skeleton height={30} duration={1.5} />
                <div className="data">
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4 col-lg-3">
            <div className="programm-wrapper">
              <div className="image">
                <Skeleton height={200} duration={1.5} />
              </div>
              <div className="content">
                <div className="header_title">
                  <Skeleton height={20} width={120} duration={1.5} />
                  <Skeleton height={20} width={60} duration={1.5} />
                </div>
                <Skeleton height={30} duration={1.5} />
                <div className="data">
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                  <div className="item">
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {pageCount > 1 && (
        <div style={{ float: "right", marginTop: "20px", marginRight: "10px" }}>
          <nav aria-label="Page navigation example">
            <ReactPaginate
              className="pagination pull-right"
              breakLabel="..."
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageCount}
              previousLabel="< "
              activeClassName="active"
              renderOnZeroPageCount={false}
            />
          </nav>
        </div>
      )}
    </div>
  );
};

export default TrainerPrograms;
